<template>
  <van-popup
    :value="visible"
    position="bottom"
    get-container="body"
    class="list-popup"
  >
    <van-nav-bar
      :border="false"
      title="查询结果"
      left-arrow
      @click-left="$emit('update:visible', false)"
    />
    <wh-mobile-list
      :data-src="agrTypeOptions[type].findApi"
      :extra-params="extraParams"
      height="calc(100vh - 46px)"
    >
      <template #default="{list, res}">
        <div v-if="res" class="total">
          共查询到{{ res.data.total }}条数据
        </div>
        <div v-for="(item, index) in list" :key="index" class="list-item" @click="showDetail(item)">
          <div class="code">
            {{ item|agrCodeFilter }}
          </div>
          <div class="name">
            {{ item|agrNameFilter }}
          </div>
          <div class="factory">
            {{ item|agrFactoryFilter }}
          </div>
        </div>
      </template>
    </wh-mobile-list>
    <agr-detail :visible.sync="popup.detail" :type="type" :agr-data="agrData" />
  </van-popup>
</template>

<script>
import WhMobileList from '@/components/public/WhMobileList/WhMobileList'
import { agrTypeOptions } from '@/constant/common'
import { agrNameFilter, agrCodeFilter, agrFactoryFilter } from '@/filter'
import AgrDetail from '@/views/More/Agriculture/components/AgrDetail'

export default {
  name: 'AgrSearchList',
  filters: {
    agrNameFilter, agrCodeFilter, agrFactoryFilter
  },
  components: { AgrDetail, WhMobileList },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    extraParams: {
      type: Object,
      default: undefined
    },
    type: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      agrTypeOptions,
      popup: {
        detail: false
      },
      agrData: {}
    }
  },
  methods: {
    showDetail(i) {
      this.agrData = i
      this.popup.detail = true
    }
  }
}
</script>

<style lang="less" scoped>
.list-popup {
  height: 100%;
  background: #F6F5F5;
}
.total {
  text-align: center;
  font-size: 14px;
  color: #666;
  padding: 10px;
}
.list-item {
  padding: 16px;
  border-bottom: 1px solid #efefef;
  font-size: 14px;
  .code {
    color: @primary-color;
  }
  .name {
    padding: 4px 0;
    color: #222;
  }
  .factory {
    color: #999;
  }
}
</style>
